const zh = {
	unrepliedChargeback: '未处理拒付交易',
	unrepliedRetrieval: '未处理调单交易',
	unrepliedRiskTransaction: '未处理风险订单',
	balance: '资金账户',
	accountBalance: '账户余额',
	totalUsdBalance: '总账户余额',
	totalUsdBalanceTip: '总账户余额为各币种账户“账户余额”换算成美元后的总和。',
	available: '可提现金额：',
	WITHDRAW: '提现',
	frozenBalance: '冻结金额',
	rollingReserveBalance: '循环保证金金额',
	fixedReserveBalance: '固定保证金金额',
	noaccount: '此群组尚未配置币种账户，请耐心等待。',
	allGroups: '所有群组',
	noFeeSetting: '此提现相关配置有误，请尽快联系销售。',

	tradeSum: '交易概览',
	group: '群组',
	website: '网站',
	omniWebsite: '网站/门店',
	currency: '交易币种',
	today: '今日累计交易',
	successfulAmount: '交易成功金额',
	todayNumber: '交易成功笔数',
	currentMonth: '本月累计交易',
	accumulated: '历史累计交易',
	settledAccount: '结算金额',
	settledNumber: '结算笔数',
	unsettledAccount: '未结算金额',
	unsettledNumber: '未结算笔数',
	todaySettled: '今日累计结算',
	todayUnsettled: '今日未结算交易',
	monthSettled: '本月累计结算',
	monthUnsettled: '本月未结算交易',
	historySettled: '历史累计结算',
	historyUnsettled: '历史未结算交易',
	cbSum: '拒付概览',
	cbSumTips: '拒付笔数/金额均按照一拒计算，拒付相关的统计时间均按照录入PingPongPay系统的时间计算',
	covertedUSD: '金额仅供参考，若需分币种查看，请指定“交易币种”',
	cbCurrentMonth: '当月累计拒付',
	cbAccumulated: '历史累计拒付',

	cbAmount: '拒付金额',
	cbNumber: '拒付笔数',
	acRate: '拒付率',
	cbWarningAmount: '拒付预警金额',
	cbWarningNumber: '拒付预警笔数',
	tip: '金额仅供参考',
	operatingGuide: '商户后台操作指南',
	guide: {
		videoTitle: '视频讲解',
		textTitle: '如需文字版材料，请下载',
		video1: 'Part1：首页',
		video2: 'Part2：交易、结算',
		video3: 'Part3：拒付',
		video4: 'Part4：提现'
	},
	certificatePending: '证件信息审核中，请耐心等待'
}

export default zh
